export default {
    name: "AppLayout"
}